export class DayOpeningHour {
  public dayId: number;
  public daysText: string;
  public timeString: string;
  public timeStrings: string[];
  public sort: number;
}
